module.exports = __webpack_public_path__ + "img/member-statistics.707af492.png";